<template>
  <div id="homePage">
    <my-header activeIndex="首页" />
    <div class="banner"></div>
    <div class="feature wrapper">
      <div class="title">平台特色</div>
      <ul class="content clearfix">
        <li
          v-for="(item, index) in featureList"
          :key="index"
          @mouseenter="featureIndex = index"
        >
          <img :src="require(`../../assets/images/feature${index + 1}.png`)" />
          <h1>{{ item.name }}</h1>
          <p
            :class="{
              animated: true,
              fadeInUp: featureIndex === index
            }"
            style="animation-duration: 1.5s;"
          >
            {{ item.details }}
          </p>
        </li>
      </ul>
    </div>
    <div class="roadmap">
      <div class="wrapper">
        <div class="title">自动驾驶教学科研平台建设路线图</div>
        <div class="time">
          <ul class="top clearfix">
            <li v-for="(item, index) in roadmapList" :key="index">
              {{ item.time }}
            </li>
          </ul>
          <div class="center clearfix">
            <div v-for="index in 7" class="clearfix" :key="index">
              <span></span>
              <img src="../../assets/images/roadmapicon.png" />
            </div>
            <span></span>
          </div>
          <ul class="bottom clearfix">
            <li v-for="(item, index) in roadmapList" :key="index">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="news wrapper">
      <div class="title">热点活动</div>
      <div class="content clearfix">
        <div class="left">
          <router-link
            v-if="newsTop.Id"
            :to="'/newsDetails/' + newsTop.Id"
            class="scale-image"
          >
            <img :src="newsTop.ImgUrl" />
            <div class="box">
              <h1 class="one-line">{{ newsTop.AcTitle }}</h1>
              <p>
                {{ newsTop.AcContent | htmlTagFilter | lengthFilter(50) }}
              </p>
              <span>{{ newsTop.PublishDate | dateFilter }}</span>
            </div>
          </router-link>
        </div>
        <div class="right">
          <router-link
            v-for="(item, index) in newsList"
            :key="index"
            :to="'/newsDetails/' + item.Id"
            class="clearfix"
          >
            <div>
              <h1>{{ item.PublishDate | dateFilter | dayFilter }}</h1>
              <p>{{ item.PublishDate | dateFilter | YMFilter }}</p>
            </div>
            <div>
              <h1 class="one-line">{{ item.AcTitle }}</h1>
              <p class="one-line">
                {{ item.AcContent | htmlTagFilter }}
              </p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="partner">
      <div class="wrapper">
        <div class="title">合作伙伴</div>
        <ul class="content clearfix">
          <li
            v-for="index in 12"
            :key="index"
            :style="
              `background:url(${require(`../../assets/images/partner${index}.png`)});background-size: 100% 100%;`
            "
            :class="{
              animated: true,
              pulse: partnerIndex === index - 1
            }"
            @mouseenter="partnerIndex = index - 1"
          >
            <a href="javascript:;"></a>
          </li>
        </ul>
      </div>
    </div>
    <my-footer />
  </div>
</template>

<script>
import MyHeader from "@/components/header";
import MyFooter from "@/components/footer";

export default {
  name: "homePage",
  created() {
    this.loadNews();
  },
  data() {
    return {
      featureIndex: -1,
      featureList: [
        {
          name: "技术领先",
          details:
            "提供业界领先的自动驾驶微型车开发套件。搭载高性能计算单元、乘用级传感器、全仿真越野车底盘，配合开放的全功能自动驾驶程序框架，为开发者提供应用、研发与教学平台。"
        },
        {
          name: "专业教学",
          details:
            "以教学和科研为目标，以无人驾驶承载的技术为核心，以专业的教学路线和丰富的资源，让自动驾驶更好入门！"
        },
        {
          name: "科教融合",
          details:
            "完善的汽车自动驾驶教学、科研及开发平台助理学校、车企搭建自动驾驶教学实践和科研环境，完成自动驾驶的教学和科研工作。"
        },
        {
          name: "工程实训",
          details:
            "基于汽车自动驾驶教学科研平台，配合选定的教材、详尽的源代码注释以及定制的实验指导书。"
        }
      ],
      roadmapList: [
        { time: "2018.8", name: "Noosphere自动驾驶教学科研平台计划发布" },
        { time: "2018.12", name: "Noosphere自动驾驶教学科研实验室环境部署" },
        { time: "2019.2", name: "Noosphere无人车硬件平台搭建完成" },
        { time: "2019.4", name: "Noosphere无人车软件功能完善" },
        {
          time: "2019.6",
          name: "Noosphere自动驾驶教学科研平台实验指导手册完成评估"
        },
        { time: "2019.11", name: "Noosphere自动驾驶教学科研平台正式发布" },
        {
          time: "2020.3",
          name:
            "以自动驾驶为核心的“产、学、研、创“一体化的人工智能教学科研实验平台"
        }
      ],
      newsTop: {},
      newsList: [],
      partnerIndex: -1
    };
  },
  methods: {
    loadNews() {
      const num = 5;
      this.requestApi("news", "getHomepageNews", { num }, res => {
        if (res.Code === 0) {
          this.newsTop = res.ActivityList[0];
          this.newsList = res.ActivityList.slice(1);
        } else {
          this.$message.error(res.Message);
        }
      });
    }
  },
  filters: {
    dayFilter(str) {
      return str.slice(-2);
    },
    YMFilter(str) {
      return str.replace(/-/g, "/").slice(0, -3);
    }
  },
  components: { MyHeader, MyFooter }
};
</script>

<style lang="less">
#homePage {
  .banner {
    width: 100%;
    padding-top: 24%;
    background: url("../../assets/images/banner.jpg");
    background-size: 100% 100%;
  }
  .feature {
    margin-bottom: 80px;
    color: #333333;
    .title {
      font-size: 30px;
      line-height: 120px;
      text-align: center;
      font-weight: bold;
    }
    .content {
      li {
        position: relative;
        float: left;
        box-sizing: border-box;
        width: 285px;
        height: 330px;
        padding: 0 20px;
        border: 1px solid #292929;
        margin-right: 20px;
        overflow: hidden;
        &:last-child {
          margin-right: 0;
        }
        &::after {
          position: absolute;
          top: -5px;
          left: 65px;
          content: "";
          width: 155px;
          height: 10px;
          background: #fff;
        }
        img {
          display: block;
          height: 90px;
          margin: 35px auto 15px;
        }
        h1 {
          margin-bottom: 20px;
          font-size: 20px;
          font-weight: bold;
          text-align: center;
        }
        p {
          line-height: 24px;
          text-align: justify;
        }
      }
    }
  }
  .roadmap {
    height: 558px;
    background: url("../../assets/images/roadmapbg.jpg");
    background-size: 100% 100%;
    color: #fff;
    .title {
      padding: 60px 0 90px;
      line-height: 60px;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      letter-spacing: 3px;
    }
    .time {
      .top,
      .bottom {
        padding: 0 57.5px;
        font-size: 20px;
        text-align: center;
        li {
          line-height: 24px;
          float: left;
          width: 155px;
        }
      }
      .bottom {
        li {
          box-sizing: border-box;
          padding: 0 22px;
          font-size: 14px;
        }
      }
      .center {
        padding: 20px 0;
        div {
          float: left;
        }
        span {
          float: left;
          width: 115px;
          height: 1px;
          margin-top: 14px;
          background: #fff;
        }
        img {
          float: left;
          margin: 0 5px;
        }
      }
    }
  }
  .news {
    color: #333333;
    padding-bottom: 80px;
    .title {
      font-size: 30px;
      line-height: 120px;
      text-align: center;
      font-weight: bold;
    }
    .content {
      .left {
        float: left;
        > a {
          position: relative;
          display: block;
          box-sizing: border-box;
          width: 510px;
          height: 340px;
          padding-top: 250px;

          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
          .box {
            position: relative;
            height: 90px;
            padding: 0 15px;
            line-height: 30px;
            font-size: 16px;
            color: #fffefe;
            background: rgba(0, 0, 0, 0.5);
            h1 {
              font-size: 20px;
              font-weight: bold;
            }
            p {
              padding-left: 10px;
            }
            span {
              position: absolute;
              right: 15px;
              bottom: 0;
              font-size: 12px;
              color: #d0cfcf;
            }
          }
        }
      }
      .right {
        float: right;
        width: 650px;
        height: 340px;
        a {
          display: block;
          height: 54px;
          border-bottom: 1px solid #d2d2d2;
          margin-bottom: 40px;
          line-height: 27px;
          &:last-child {
            padding-bottom: 0;
          }
          > div {
            float: left;
            &:first-child {
              width: 50px;
              margin-right: 20px;
              text-align: center;
              font-size: 12px;
              color: #999999;
              h1 {
                font-size: 20px;
              }
            }
            &:last-child {
              width: 580px;
              h1 {
                font-size: 18px;
              }
              p {
                color: #666666;
              }
            }
          }
        }
      }
    }
  }
  .partner {
    height: 558px;
    background: url("../../assets/images/partnerbj.jpg");
    background-size: 100% 100%;
    .title {
      padding-bottom: 45px;
      line-height: 120px;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #ffffff;
    }
    .content {
      li {
        float: left;
        width: 195px;
        height: 126px;
        margin: 0 6px 25px 0;
        &:nth-child(6n) {
          margin-right: 0;
        }
        a {
          display: block;
          height: 100%;
        }
      }
    }
  }
}
</style>
